module.exports = __webpack_public_path__ + "img/traffit.a154832c.png";